var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinocular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4 2.44772 4.44772 2 5 2H8C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4V5H5V4C4.44772 4 4 3.55228 4 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15 2.44772 15.4477 2 16 2H19C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4V5H16V4C15.4477 4 15 3.55228 15 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93111 6C4.40647 6 3.97103 6.40545 3.93365 6.92875L3.17734 17.5171C3.28333 17.5058 3.39098 17.5 3.49999 17.5H9.49999C9.609 17.5 9.71665 17.5058 9.82264 17.5171L9.67856 15.5H9.49999C8.11928 15.5 6.99999 14.3807 6.99999 13V10C6.99999 8.7522 7.91416 7.71791 9.1093 7.53035L9.06633 6.92875C9.02895 6.40545 8.59351 6 8.06887 6H4.93111Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7828 9.04055C14.6931 9.01416 14.5982 9 14.5 9H9.5C9.40178 9 9.30686 9.01416 9.21718 9.04055C8.80263 9.16256 8.5 9.54594 8.5 10V13C8.5 13.5523 8.94772 14 9.5 14H14.5C15.0523 14 15.5 13.5523 15.5 13V10C15.5 9.54594 15.1974 9.16256 14.7828 9.04055Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3214 15.5H14.5C15.8807 15.5 17 14.3807 17 13V10C17 8.7522 16.0858 7.71791 14.8907 7.53035L14.9337 6.92875C14.971 6.40545 15.4065 6 15.9311 6H19.0689C19.5935 6 20.029 6.40545 20.0663 6.92875L20.8227 17.5171C20.7167 17.5058 20.609 17.5 20.5 17.5H14.5C14.391 17.5 14.2833 17.5058 14.1773 17.5171L14.3214 15.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0757 19.0609C13.4539 19.2439 13 19.8189 13 20.5C13 21.3284 13.6716 22 14.5 22H20.5C21.3284 22 22 21.3284 22 20.5C22 19.8189 21.5461 19.2439 20.9243 19.0609C20.7898 19.0213 20.6474 19 20.5 19H14.5C14.3526 19 14.2102 19.0213 14.0757 19.0609Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92431 19.0609C9.78977 19.0213 9.64737 19 9.5 19H3.5C3.35263 19 3.21023 19.0213 3.07569 19.0609C2.4539 19.2439 2 19.8189 2 20.5C2 21.3284 2.67157 22 3.5 22H9.5C10.3284 22 11 21.3284 11 20.5C11 19.8189 10.5461 19.2439 9.92431 19.0609Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocular);
export default __webpack_public_path__ + "static/media/binocular.c67acd3b98ab2a7c0c7b6d001318e2f7.svg";
export { ForwardRef as ReactComponent };